<template>
  <div>
    <div class="section section-space">
      <div class="greet" v-show="!isNoApplication" v-text="greetText"></div>
      <active-programs/>
    </div>
    <div class="section section-space">
      <pending-apps/>
    </div>
    <div class="section section-space">
      <resource/>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: 'HomeList',
  data() {
    return {
      isShowPopup: false
    };
  },
  mounted() {
  },
  computed: {
    ...mapState({
      isNoApplication: state => state.isNoApplication,
      userInfo: state => state.userInfo
    }),
    greetText() {
      return `Welcome, ${this.userInfo.firstName}!`;
    }
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.section {
  background-color: $bg-color-white;
  border-radius: 7px;

  .greet {
    padding: 50px 50px 0px 50px;
    font-size: $font-size-largest-more;
    color: $tab-active;

    @media screen and (max-width: $max-width-phone) {
      padding: 15px 5px 5px 15px;
      font-size: $font-size-larger;
    }
  }
}

.section-space {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/home-list/HomeList.vue